import { ViewSGBSApplicationFormData } from "../data/ViewSGBSApplicationForm.data";

export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                    Point: item?.valueOrdering || 0
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "typeOfCompany": filterDropDownList("Type Of Company"),
        "mainContactPerson": filterDropDownList("Corporate Roles"),
        "serviceCategory": filterDropDownList("Serivce Category"),
        "mainContactPhone": filterDropDownList("Country Code"),
        "criteriaSelected": filterDropDownList("Approved Criteria"),
        "mainContactPhoneCountryCode": filterDropDownList("Country Code"),

    };

    const formFields = [
        ...ViewSGBSApplicationFormData.formFields
    ];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};


export const setmainContactFields = ( apiResponse ) => {
    const filterDropDownList = ( dropdownName ) => {
        let list = apiResponse.reduce( ( acc, item ) => {
            if ( item.dropdownName === dropdownName ) {
                acc.push( {
                    value: item.id,
                    label: item.name,
                } );
            }
            return acc;
        }, [] );

        return list;
    };

    const dropdownLists = {
        "mainContactPerson": filterDropDownList("Main Contact Person"),
        "mainContactPhone": filterDropDownList("Country Code"),
       
    };

    const formFields = [ ...ViewSGBSApplicationFormData.formFields, ];

    formFields.forEach( field => {
        const dropdownList = dropdownLists[ field?.id ];
        if ( dropdownList )
        {
            field.fieldSetting.options = dropdownList;
        }
    } );
};